import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

export default function RedirectHandler() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;

    // Exact redirects map
    const exactRedirects = {
      "/services": "/ydelser",
      "/about": "/om-os",
      "/contact": "/kontakt",
      "/projects": "/projekter",
      "/da": "/",
      "/da/": "/",
      "/da/ydelser": "/ydelser",
      "/da/projekter": "/projekter",
      "/da/om-os": "/om-os",
      "/da/kontakt": "/kontakt",
      "/totalentreprise": "/ydelser/totalentreprise",
      "/projektering-af-byggeri": "/ydelser/projektering-af-byggeri",
      "/toemrerarbejde": "/ydelser/toemrerarbejde",
      "/renovering": "/ydelser/renovering",
      "/totalrenovering": "/ydelser/totalrenovering",
      "/byggepladsservice": "/ydelser/byggepladsservice",
      "/specialprojekter": "/ydelser/specialprojekter",
      "/byggeprojekt": "/ydelser/byggeprojekt",
      "/haandvaerker-byggeprojekt": "/ydelser/haandvaerker-byggeprojekt",
      "/haandvaerker": "/ydelser/haandvaerker-byggeprojekt",
      "/en/turnkey": "/en/services/turnkey",
      "/en/building-engineering": "/en/services/building-engineering",
      "/en/carpentry": "/en/services/carpentry",
      "/en/renovation": "/en/services/renovation",
      "/en/total-renovation": "/en/services/total-renovation",
      "/en/site-services": "/en/services/construction-site-services",
      "/en/custom-projects": "/en/services/custom-projects",
      "/en/construction-projects": "/en/services/construction-projects",
      "/en/trades-construction-projects": "/en/services/trades-construction-projects",
      "/en/trades": "/en/services/trades-construction-projects",
    };

    if (exactRedirects[path]) {
      navigate(exactRedirects[path], { replace: true });
      return;
    }

    // Dynamic redirects for projects and services
    if (path.startsWith("/da/ydelser/")) {
      const slug = path.substring("/da/ydelser/".length);
      navigate(`/ydelser/${slug}`, { replace: true });
      return;
    }
    if (path.startsWith("/projects/")) {
      const slug = path.substring("/projects/".length);
      navigate(`/projekter/${slug}`, { replace: true });
      return;
    }
    if (path.startsWith("/da/projekter/")) {
      const slug = path.substring("/da/projekter/".length);
      navigate(`/projekter/${slug}`, { replace: true });
      return;
    }
  }, [location, navigate]);

  return null;
}
